import { config } from "../../config";
import { useGetGameTimer } from "../../hooks/use-get-game-timer";

interface TimerProps {
  startDateTime: string;
  isSecondHalfPlaying: boolean;
}

const Timer = ({ startDateTime, isSecondHalfPlaying }: TimerProps) => {
  const date = new Date(startDateTime);
  if (isSecondHalfPlaying) {
    date.setSeconds(date.getSeconds() - config.halftimeDuration);
  }
  const time = useGetGameTimer(date.toISOString());

  return <div className="px-2">{time}</div>;
};

export default Timer;
